// import OrganizationView from "@/views/app/OrganizationView";
import OrganizationsView from "@/views/app/organization/OrganizationsView";
import SandboxView from "@/views/app/SandboxView";
import UsersView from "@/views/app/organization/UsersView";

import EventRouter from "@/router/event.router";

import gettext from "@/language";

import { useGeneralStore } from "@/store/general.store";
import ErrorService from "@/services/error.service";

export default {
  path: "organizations",
  name: "app.organization",
  // component: OrganizationView,
  children: [
    {
      path: "",
      redirect: {
        name: "app.organizations.all",
      },
    },
    {
      path: "all",
      name: "app.organizations.all",
      component: OrganizationsView,
      meta: {
        title: gettext.$gettext("Organizations"),
      },
    },
    {
      path: ":organizationId",
      name: "app.organization.single",
      // component: OrganizationView,
      beforeEnter: async (to, from, next) => {
        const generalStore = useGeneralStore();
        let organizationId = to.params.organizationId;
        try {
          await generalStore.getOrganization(organizationId);
          next();
        } catch (error) {
          // console.error("Fetch organization error:", error);
          ErrorService.showError(error);
          next({ name: "app.organizations.all" });
        }
      },
      redirect: {
        name: "app.organizations.events.all",
      },
      children: [
        {
          path: "users/",
          name: "app.organizations.users",
          component: UsersView,
          meta: {
            title: gettext.$gettext("Users"),
          },
        },
        {
          path: "sandbox",
          name: "app.sandbox",
          component: SandboxView,
          meta: {
            title: gettext.$gettext("Sandbox"),
          },
        },
        EventRouter,
      ],
    },
  ],
};
